import { TaskAssignee } from '@percent/admin-dashboard/api/actions/grantProgram/grantProgram.types'

export const mockTaskAssignees: TaskAssignee[] = [
  {
    id: 'task_assignee_1',
    email: 'test-email+1@gmail.com'
  },
  {
    id: 'task_assignee_2',
    email: 'test-email+2@gmail.com'
  }
]
